export default {
  SITUACAO_CONCURSO_ENUM: [
    {
      label: 'Aberto',
      value: 'ABE',
      color: 'grey'
    },
    {
      label: 'Em Andamento',
      value: 'EAD',
      color: 'primary'
    },
    {
      label: 'Cancelado',
      value: 'CAC',
      color: 'red'
    },
    {
      label: 'Concluído',
      value: 'N',
      color: 'green'
    }
  ],
  ATIVO_ENUM_BADGE: [
    {
      label: 'Sim',
      value: 'S',
      color: 'green'
    },
    {
      label: 'Não',
      value: 'N',
      color: 'red'
    }
  ],
  ATIVO_ENUM: [
    {
      label: 'Sim',
      value: 'S',
      color: 'green'
    },
    {
      label: 'Não',
      value: 'N',
      color: 'grey'
    }
  ],
  SERVIDOR_SITUACAO_ENUM: [
    {
      label: 'Ativo',
      value: 'Ativo',
      color: 'green'
    },
    {
      label: 'Afastado',
      value: 'Afastado',
      color: 'red'
    },
    {
      label: 'Desligado',
      value: 'Desligado',
      color: 'grey'
    }
  ],
  PLANEJAMENTO_PAGINA_INICIAL: [
    {
      icone: 'las la-money-bill',
      descricao: 'PPA - Plano plurianual',
      cor: '#32a852',
      path: 'ppa'
    },
    {
      icone: 'las la-money-check-alt',
      descricao: 'LDO - Lei das diretrizes orçamentárias',
      cor: '#32a852',
      path: 'ldo'
    },
    {
      icone: 'las la-coins',
      descricao: 'LOA - Lei orçamentária anual',
      cor: '#32a852',
      path: 'loa'
    },
    {
      icone: 'las la-newspaper',
      descricao: 'Publicações',
      cor: '#32a852',
      path: 'publicacoes'
    }
  ],
  EXECUCAO_PAGINA_INICIAL: [
    {
      icone: 'las la-funnel-dollar',
      descricao: 'Despesa detalhada',
      cor: '#bf443b'
    },
    {
      icone: 'las la-hand-holding-usd',
      descricao: 'Receita',
      cor: '#bf443b'
    },
    {
      icone: 'las la-plus-square',
      descricao: 'Receita extra',
      cor: '#bf443b'
    },
    {
      icone: 'las la-hotel',
      descricao: 'Diárias e passagens',
      cor: '#bf443b'
    },
    {
      icone: 'las la-wallet',
      descricao: 'Reembolso de despesas e adiantamento',
      cor: '#bf443b'
    },
    {
      icone: 'las la-file-invoice-dollar',
      descricao: 'Demonstrativos fiscais anexos LRF (RGF e RREO)',
      cor: '#bf443b'
    },
    {
      icone: 'las la-id-card',
      descricao: 'Pessoal',
      cor: '#bf443b'
    },
    {
      icone: 'las la-file-signature',
      descricao: 'Convênios',
      cor: '#bf443b'
    }
  ],
  RA_PAGINA_INICIAL: [
    {
      icone: 'las la-gavel',
      descricao: 'Licitações',
      cor: '#2c6ca8',
      path: 'licitacoes'
    },
    {
      icone: 'las la-file-signature',
      descricao: 'Contratos',
      cor: '#2c6ca8',
      path: 'licitacoes'
    }
  ],
  PORTAL_PAGINA_INICIAL: [
    {
      icone: 'las la-info-circle',
      descricao: 'Acesso a informação',
      cor: '#093370',
      path: 'estruturaOrganizacional'
    },
    {
      icone: 'las la-rss',
      descricao: 'Publicação',
      cor: '#093370',
      path: 'estruturaOrganizacional'
    },
    {
      icone: 'las la-building',
      descricao: 'Concursos',
      cor: '#093370',
      path: 'concursos'
    },
    {
      icone: 'las la-network-wired',
      descricao: 'Estrutura organizacional',
      cor: '#093370',
      path: 'estruturaOrganizacional'
    },
    {
      icone: 'las la-hard-hat',
      descricao: 'Obras',
      cor: '#093370',
      path: 'estruturaOrganizacional'
    },
    {
      icone: 'las la-comment-alt',
      descricao: 'Fale conosco',
      cor: '#093370',
      path: 'estruturaOrganizacional'
    },
    {
      icone: 'las la-university',
      descricao: 'SIC - Presencial',
      cor: '#093370',
      path: 'estruturaOrganizacional'
    },
    {
      icone: 'las la-file-export',
      descricao: 'Relatórios estatísticos',
      cor: '#093370',
      path: 'estruturaOrganizacional'
    }
  ],
  TIPO_LIMPEZA_DUCUMENTO: {
    JUR: 'ALFANUMERICO',
    FIS: 'NUMERICO',
    OUT: 'LIVRE',
    CPF: 'NUMERICO',
    CNPJ: 'ALFANUMERICO',
    NIF: 'LIVRE'
  }
}
